import type { PackageRegistryEntry } from '@shared/core';
import type { LoggerEnvironmentConfig } from '@shared/logger';
import { LoggerPackageBootstrap } from '@shared/logger';
import { BrowserSentryAdapter } from '@shared/logger/sentry/browser';

export const LOGGER_REGISTRY: PackageRegistryEntry<LoggerEnvironmentConfig> = {
  definition: new LoggerPackageBootstrap('browser'),
  config: {
    development: { options: { level: 'info' }, adapters: [new BrowserSentryAdapter('info')] },
    preview:     { options: { level: 'warn' }, adapters: [new BrowserSentryAdapter('warn')] },
    production:  { options: { level: 'error' }, adapters: [new BrowserSentryAdapter('error')] },
  },
};
